module.exports = __webpack_public_path__ + "static/media/Roman Soldier.d52c1720.jpg";